<template>
  <!--Used for message display and opening OTPVerificationModal-->
  <content-modal
    class="message-modal otp-confirmation-modal otp"
    :visible="visible"
    :close-aria-label="closeAriaLabel"
    :size="size"
    :primary-button-disabled="primaryButtonDisabled"
    :auto-hide-off="autoHideOff"
    @modal-shown="actionShown"
    @modal-hidden="actionHidden"
    @modal-hide-request="actionHideRequest"
    @primary-click="actionPrimary"
    @secondary-click="actionSecondary"
  >
    <template v-if="use_title" #title>{{ params.title }}</template>
    <template v-if="use_content" #content>
      <modal-content>
        {{ params.content }}
      </modal-content>
    </template>
    <template v-if="use_secondaryButton" #secondary-button>
      {{ t("button_cancel") }}
    </template>
    <template v-if="use_primaryButton" #primary-button>{{ t("button_proceed") }}</template>
  </content-modal>
</template>

<script setup lang="ts">
import { ref, getCurrentInstance } from "vue";
import { useI18n } from "vue-i18n";
import modalEventBus from "@plugins/modal/service/event-bus";
import ContentModal from "@plugins/modal/components/ContentModal.vue";
import ModalContent from "@plugins/modal/components/ModalContent.vue";
import Auth from "@plugins/otp";
import { OTPParams } from "@plugins/otp/types.ts";

const { t } = useI18n();

const props = defineProps<{ params: OTPParams }>();

const closeAriaLabel = ref("Close");
const size = ref("small");
const visible = ref(true);
const autoHideOff = ref(true);
const use_title = ref(true);
const use_content = ref(true);
const use_secondaryButton = ref(true);
const use_primaryButton = ref(true);
const primaryButtonDisabled = ref(false);
const actionPrimaryTriggered = ref(false);

function showOTPVerificationModal(): Promise<boolean> {
  return new Promise(() => {
    const modalParams = {
      title: props.params.verificationTitle,
      content: props.params.verificationContent,
      useStateButton: true,
      primaryBtnLabel: t("button_proceed"),
      secondaryBtnLabel: t("button_cancel"),
      email: props.params.email,
      actionPrimary: props.params.actionPrimary,
      actionSecondary: props.params.actionSecondary,
      requireSendOTP: true,
      sendOTP: props.params.sendOTP,
      resendOTP: props.params.resendOTP,
      verifyOTP: props.params.verifyOTP,
    };
    Auth.$auth.showOTPVerificationModal(modalParams);
  });
}

function actionHideRequest(event: Record<string, unknown>) {
  const reason = event["cv:reason"];
  if (reason !== "external-click" && !actionPrimaryTriggered.value) {
    props.params.actionSecondary();
    visible.value = false;
  }
}

function actionShown() {
  visible.value = true;
}

function actionHidden() {
  visible.value = false;
  const inst = getCurrentInstance();
  modalEventBus.$emit("modal-hidden", inst?.vnode.key);
}

function actionPrimary() {
  visible.value = false;
  actionPrimaryTriggered.value = true;
  showOTPVerificationModal();
}

function actionSecondary() {
  props.params.actionSecondary();
  visible.value = false;
}
</script>
